import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, of, throwError, tap } from 'rxjs';
import { concatMap, delay, retryWhen } from 'rxjs/operators';
import { InsightsService, NetworkService, UIService, SettingsService } from 't4core';

@Injectable()
export class MonitorInterceptor implements HttpInterceptor {

  constructor(
    private insights: InsightsService,
    private networkService: NetworkService,
    private UI: UIService,
    private settings: SettingsService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.settings.Environment != 0) {
      return next.handle(request).pipe(
        retryWhen(errors => errors.pipe(
          concatMap((error, retryCount) => {
            if (retryCount < 3 && (error.status === 0 || error.status === undefined)) {
              this.insights.logEvent(`Retry http: ${JSON.stringify(request)}`);
              this.networkService.updateStatus('retrying');
              return of(error);
            } else {
              this.UI.alert("Intellitrailer.Monitor.Retry.ErrorMessage", "Failed", "Intellitrailer.Monitor.Retry.msgErrorMessage", "Something went wrong. Please try again later.");
              this.networkService.updateStatus(navigator.onLine ? 'online' : 'offline');
              return throwError(() => error);
            }
          }),
          delay(3000)
        )),
        tap(() => {
          this.networkService.clearRetryingStatus();
        })
      );
    }
    else {
      return next.handle(request).pipe(
        retryWhen(error => {
          var count = 0;
          return error.pipe(
            concatMap((error, count) => {
              if (count <= 3 && (error.status == 0 || error.status == undefined)) {
                this.insights.logEvent("Retry http: " + JSON.stringify(request));

                count++;
                return of(error);
              }

              return throwError(error);
            }),
            delay(3000)
          )
        })
      );
    }
  }
}
